<template>    
    <b-container fluid class="div-background">
        <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
        <b-row align-h="between" align-v="center" class="pb-3">
            <b-col cols="auto">
                
            </b-col>
            <b-col cols="auto">
                <b-button  v-b-modal.modal-1 variant="success" size="lg">設定漲跌勢作物</b-button>
            </b-col>
        </b-row>
        <!--漲跌勢作物modal-->
        <b-modal id="modal-1" size="lg" title="設定漲跌勢作物" hide-footer hide-header-close>
            <b-row style="margin-bottom: 0.5rem;" align-h="center">
                <b-col sm="12" md="12" lg="6" xl="6">
                    <b-button class="white-text-btn gray" @click="changeCategory(0)"
                        >ALL</b-button
                    >
                    <b-button class="white-text-btn blue" @click="changeCategory(1)"
                        >水果類</b-button
                    >
                    <b-button class="white-text-btn orange" @click="changeCategory(2)"
                        >根莖菜類</b-button
                    >
                    <b-button class="white-text-btn green" @click="changeCategory(3)"
                        >葉菜類</b-button
                    >
                    <b-button class="white-text-btn purple" @click="changeCategory(4)"
                        >花果菜類</b-button
                    >
                    <b-button class="white-text-btn darkblue" @click="changeCategory(5)"
                        >菇菌類</b-button
                    >
                    <b-button class="white-text-btn yellow" @click="changeCategory(6)"
                        >五穀雜糧類</b-button
                    >
                    <b-button class="white-text-btn brown" @click="changeCategory(7)"
                        >其他類</b-button
                    >
                    
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col sm="12" md="12" lg="6" xl="6">
                    <b-form-input
                        class="farminput"
                        v-model="crop.filter"
                        placeholder="請輸入作物關鍵字查詢"
                        debounce="500"
                        max="10"
                    ></b-form-input>
                    <div class="selectItem" style="">
                        <b-form-group>
                            <template #label>
                                <!-- <b>Choose your flavours:</b><br> -->
                                <b-form-checkbox
                                    v-model="allSelected"
                                    :indeterminate="indeterminate"
                                    aria-describedby="flavours"
                                    aria-controls="flavours"
                                    @change="toggleAll"
                                >
                                    {{ allSelected ? '全選' : '全選' }}
                                </b-form-checkbox>
                            </template>
                            
                            <template v-slot="{ ariaDescribedby }"  >
                                <b-form-checkbox-group
                                id="flavors"
                                v-model="selected"
                                :aria-describedby="ariaDescribedby"
                                name="flavors"
                                class="ml-4"
                                aria-label="Individual flavours"
                                stacked
                                >
                                <template v-for="(item) in trade.mainTradeItems">
                                    <b-form-checkbox :value="item.value" :key="item.value">{{item.common}}:{{ item.name }}</b-form-checkbox>
                                </template>
                                </b-form-checkbox-group>
                            </template>
                            </b-form-group>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pt-4 justify-content-end">
                <b-col cols="auto">
                    <b-button variant="primary" @click="save">儲存變更</b-button>
                    <b-button @click="closeModal" style="margin-left: 5px;">取消</b-button>
                </b-col>
            </b-row>
        </b-modal>
        <!--漲跌勢-->

        <div class="Info_Area">
            <h3 class="mb-4"><span class="icon icon-UpDown" /> {{cropDate}}我的蔬果漲跌勢</h3>
            <template v-if="ifupdownloading">
            <b-row style="text-align: center">
                <b-col
                ><b-spinner variant="success" label="Spinning"></b-spinner
                ></b-col>
            </b-row>
            </template>
            <template v-else>
            <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="3" cols-xl="3">
                <b-col>
                    <div class="priceRise">
                        <div class="cropGroupTitle"> <b-icon-arrow-up></b-icon-arrow-up>漲勢作物(元/公斤)</div>
                        <div class="cropGroup scrollStyle"> 
                        <template v-for="(item, index) in trade.uplist">
                        <a :key="index" href="javascript:void(0);" >
                            <div class="cropGroupList">
                                <div class="cropGroupItem" style="color: black;">{{ item.CROP }}</div>
                                <div class="cropGroupPrice">{{item.AVG}}</div>
                            </div>
                        </a>
                        </template>
                    </div>
                    </div>
                </b-col>
                <!-- v-if="trade.downlist.length > 0" -->
                <b-col class="pt-4 pt-sm-0 pt-md-0 pt-lg-0 pt-xl-0" >
                    <div class="priceDown">
                        <div class="cropGroupTitle"><b-icon-arrow-down></b-icon-arrow-down>跌勢作物(元/公斤)</div>
                        <div class="cropGroup scrollStyle priceRise">
                            <template v-for="(item, index) in trade.downlist">
                                <a :key="index" href="javascript:void(0);">
                                <div class="cropGroupList">
                                    <div class="cropGroupItem" style="color: black;">{{ item.CROP }}</div>
                                    <div class="cropGroupPrice">{{item.AVG}}</div>
                                </div>
                                </a>
                            </template>
                        </div>
                    </div>
                </b-col>
                <b-col class="pt-4 pt-sm-0 pt-md-0 pt-lg-0 pt-xl-0">
                    <div class="priceSmooth">
                        <div class="cropGroupTitle"><b-icon-dash></b-icon-dash>無跌勢作物(元/公斤)</div>
                        <div class="cropGroup scrollStyle priceRise">
                            <template v-for="(item, index) in trade.nonelist">
                                <a :key="index" href="javascript:void(0);">
                                <div class="cropGroupList">
                                    <div class="cropGroupItem" style="color: black;">{{ item.CROP }}</div>
                                    <div class="cropGroupPrice">{{item.AVG}}</div>
                                </div>
                                </a>
                            </template>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="margin: 5px 5px 5px 5px">
                    <span>{{ warningtext }}</span>
                    <br />
                    <span>{{ warningtext2 }}</span>
                    <br />
                    <span>{{ warnungtext3 }}</span>
                </b-col>
            </b-row>
            </template>
        </div>

    </b-container>
</template>

<script>

export default {

data() {
return {
    breadcrumbItems: [
    {
        text: "首頁",
        href: "#/",
    },
    {
        text: "我的漲跌勢",
        active: true,
    },
    ],
    warningtext:
    "漲跌勢判斷以RSV>80為漲勢、<20為跌勢；RSV=((加權平均-最近9日最低均價)/(最近9天最高均價-最近9天最低價))*100",
    warningtext2: "*RSV指未成熟隨機值",
    warnungtext3:"※無漲跌勢判斷以RSV≤80且≥ 20",
    flavours: [
        {value:'0',name:"Orange"},
        {value:'1',name:'Grape'},
        {value:'2',name:'Apple'},
        {value:'3',name:'Lime'},
        {value:'4',name:'Very Berry'}
    ],
    selected: [],
    Category:false,
    allSelected: false,
    indeterminate: false,
    crop:{
        filter:null,
        fruitList:[],
        rhizomeList:[],
        leafyList:[],
        FlowerFruitList:[],
        MushroomList:[]
    },
    items:[
        'Programming',
        'Design',
        'Vue',
        'Vuetify',
    ],
    ifupdownloading:false,
    cropDate:null,
    trade: {
        mainTradeOptions:[],
        mainTradeItemsTemp:[],
        mainTradeItems:[],
        originMainTradeItems:[],
        upSelected:{label: "請選擇", code: "請選擇", disabled: false },
        upoptions:[],
        uplist: [
            
        ],
        originUplist:[],
        downSelected:{label: "請選擇", code: "請選擇", disabled: false },
        downoptions:[],
        downlist: [],
        originDownlist:[],
        nonelist:[],
    },
    options: [
        { value: null, text: 'Please select an option' },
        { value: 'a', text: 'This is First option' },
        { value: 'b', text: 'Selected Option' },
        { value: { C: '3PO' }, text: 'This is an option with object value' },
        { value: 'd', text: 'This one is disabled', disabled: true }
    ],
    apiGetMainTrade: (data) =>
        this.userRequest.post("/API/Default/GetMainTrade", data),
    apiGetMyMainTrade: (data) =>
        this.userRequest.post("/API/Default/GetMyMainTrade", data),
    apiUpdateMyMainTrade: (data) =>
        this.userRequest.post("/API/Default/UpdateMyMainTrade", data),
    apiGetMyMainTradeUP: (data) =>
        this.userRequest.post("/API/Default/GetMyMainTradeUP", data),
    apiGetMyMainTradeDOWN: (data) =>
        this.userRequest.post("/API/Default/GetMyMainTradeDOWN", data),
    apiMainTrade: (data) =>
        this.userRequest.post("/API/Default/MainTradeApi", data),
    };
},
created() {
    this.checkLogin();
},
methods:{
    checkLogin() {
        let TokenID = sessionStorage.getItem("TokenID");
        if (TokenID) {
        this.init();
        } else {
        alert("未有權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
        }
    },
    async init(){
        await this.FunctionToken(this.getMainTrade,{});
        await this.FunctionToken(this.GetMyMainTrade,{});
        await this.FunctionToken(this.GetMyMainTradeUP,{});
        await this.FunctionToken(this.GetMyMainTradeDOWN,{});
        await this.FunctionToken(this.MyMainTradeNone,{TYPE:"NONE"});
    },
    toggleAll(checked) {
        this.selected = checked ? (this.trade.mainTradeItems.map((item) => {return item.value})) : []
    },
    //
    getMainTrade(data){
        this.apiGetMainTrade(data)
            .then((res) =>{
                const json = JSON.parse(res.data);
                //console.log("getMainTrade",json)
                if(json.Status){
                    let jsondata =JSON.parse(json.Data);
                    //console.log("getMainTrade",jsondata)
                    jsondata.map((item) =>{
                        let index = this.trade.mainTradeItems.findIndex((x) => x.value == item.CROP_CODE)
                        //let index2 = this.trade.mainTradeOptions.findIndex((x) => x.code == item.CROP_CODE)
                        if(index == -1){
                            this.trade.mainTradeItems.push({
                                value:item.CROP_CODE,
                                name: item.CROP,
                                type:item.V_TYPE,
                                common:item.V_NAME
                            });
                        }
                    })
                    this.trade.originMainTradeItems = this.trade.mainTradeItems;
                    //this.trade.mainTradeItemsTemp=this.trade.mainTradeItems;
                }
                
            })
    },
    //取得已訂閱的漲跌勢作物
    GetMyMainTrade(data){
        this.apiGetMyMainTrade(data)
            .then((res) =>{
                let json = JSON.parse(res.data);
                //console.log("GetMyMainTrade",json)
                if(json.Status){
                    this.selected=[];
                    let jsondata = JSON.parse(json.Data);
                    //console.log(["GetMyMainTrade",jsondata]);
                    if(jsondata != null){
                        if(jsondata.AM_CROP =="ALL"){
                            let obj =this.trade.mainTradeItems.map((item) => {return item.value})
                            this.selected = obj;
                        }
                        else if(jsondata.AM_CROP != ""){
                            let itemArr = jsondata.AM_CROP.split(',');
                        //console.log(["GetMyMainTrade",itemArr])
                            itemArr.map((item) =>{
                                this.selected.push(item);
                            })
                            this.sortTrade();
                        }
                        
                    }
                }
            })
    },
    GetMyMainTradeUP(data){
        this.apiGetMyMainTradeUP(data)
            .then((res) =>{
                let json = JSON.parse(res.data);
                //console.log(json)
                if (json.Status){
                    
                    let jsonData = JSON.parse(json.Data);
                    //console.log(["apiGetMainTradeUP",jsonData])
                    if(jsonData.length != 0 ){
                        let date = jsonData[0].DATE.split("T");
                        let getdate = date[0].split("-");
                        this.cropDate = getdate[1].toString() + "/" + getdate[2].toString();
                        this.trade.uplist = jsonData;
                    }else{
                        this.trade.uplist =[];
                    }
                    
                }
            })
    },
    GetMyMainTradeDOWN(data){
        this.apiGetMyMainTradeDOWN(data)
            .then((res) =>{
                let json = JSON.parse(res.data);
                //console.log(json)
                if (json.Status){
                    let jsonData = JSON.parse(json.Data);
                    console.log(["apiGetMyMainTradeDOWN",jsonData,jsonData.length != 0,this.cropDate == null])
                    if(jsonData.length != 0){
                        if(this.cropDate == null){
                            let date = jsonData[0].DATE.split("T");
                            let getdate = date[0].split("-");
                            this.cropDate = getdate[1].toString() + "/" + getdate[2].toString();
                        }
                        console.log("trade.downlist ")
                        this.trade.downlist = jsonData;
                        
                    }else{
                        this.trade.downlist =[];
                    }
                    
                }
                console.log("trade.downlist ",this.trade.downlist)
            })
    },
    MyMainTradeNone(data){
        this.apiMainTrade(data)
            .then((res) =>{
                let json = JSON.parse(res.data);
                //console.log(json)
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.length != 0){
                        if(this.cropDate == null){
                            let date = jsonData[0].DATE.split("T");
                            let getdate = date[0].split("-");
                            this.cropDate = getdate[1].toString() + "/" + getdate[2].toString();
                        }
                        this.trade.nonelist = jsonData;
                    }
                    else{
                        this.trade.nonelist =[];
                    }
                }
            })
    },
    async save(){
        let itemString="";
        if(this.allSelected && !this.indeterminate){
            itemString ="ALL";
        }
        else{
            let count = 0;
            this.selected.map((item) => {
                if(count != this.selected.length-1){
                    itemString += item +",";
                }
                else{
                    itemString += item;
                }
                count++;
            })
        }
        
        //console.log("itemString",itemString);
        await this.FunctionToken(this.UpdateMyMainTrade,{AM_CROP:itemString});
        
        
    },
    async closeModal(){
        await this.FunctionToken(this.GetMyMainTrade,{});
        this.$bvModal.hide('modal-1');
        this.changeCategory(0);
    },
    UpdateMyMainTrade(data){
        this.apiUpdateMyMainTrade(data)
            .then( async(res) =>{
                const json = JSON.parse(res.data);
                if(json.Status){
                    alert("儲存成功")
                    await this.FunctionToken(this.GetMyMainTrade,{});
                    await this.FunctionToken(this.GetMyMainTradeUP,{});
                    await this.FunctionToken(this.GetMyMainTradeDOWN,{});
                    await this.FunctionToken(this.MyMainTradeNone,{TYPE:"NONE"});
                    this.changeCategory(0);
                    this.crop.filter =null;
                    this.$bvModal.hide('modal-1');
                }
                //console.log(json)
            })
    },
    changeCategory(val){
        //console.log("this.IsNull(this.crop.filter)",this.IsNull(this.crop.filter))
        if(!this.IsNullEmpty(this.crop.filter))
        {
            this.Category = true;
            this.crop.filter = null;
        }
        let temp=[];
        let oldData = [];
        oldData = this.trade.originMainTradeItems.concat();
        if(val == 0) temp = oldData;
        else if(val == 1) temp = oldData.filter((item) => item.type=="水果類");
        else if(val == 2) temp = oldData.filter((item) => item.type=="根莖菜類");
        else if(val == 3) temp = oldData.filter((item) => item.type=="葉菜類");
        else if(val == 4) temp = oldData.filter((item) => item.type=="花果菜類");
        else if(val == 5) temp = oldData.filter((item) => item.type=="菇菌類");
        else if(val == 6) temp = oldData.filter((item) => item.type=="五穀雜糧類");
        else temp = oldData.filter((item) => item.type=="其他類");
      //console.log("this.subscriptionList",this.subscriptionList)
        
        this.trade.mainTradeItems = temp.sort((a,b)=>{
            if(this.selected.indexOf(a.value) > this.selected.indexOf(b.value))
            {
                return -1;
            }
            else{
                return 0;
            }
        });
    },
    sortTrade(){
        let temp=[];
        temp = this.trade.mainTradeItems.concat();
        this.trade.mainTradeItems=[];

        this.trade.mainTradeItems = temp.sort((a,b)=>{
            if(this.selected.indexOf(a.value) > this.selected.indexOf(b.value))
            {
                return -1;
            }
            else{
                return 0;
            }
        });
    }
},
watch: {
    selected(newValue) {
        // Handle changes in individual flavour checkboxes
        //console.log([newValue,oldValue])
        if (newValue.length === 0) {
            this.trade.mainTradeItems =this.trade.originMainTradeItems;
            this.indeterminate = false
            this.allSelected = false
        } else if (newValue.length === this.trade.originMainTradeItems.length) {
            this.trade.mainTradeItems =this.trade.originMainTradeItems;
            this.indeterminate = false
            this.allSelected = true
        } else {
            //this.trade.mainTradeItems=[];
            let temp=[];
            temp = this.trade.mainTradeItems.concat();
            this.trade.mainTradeItems=[];

            this.trade.mainTradeItems = temp.sort((a,b)=>{
                if(newValue.indexOf(a.value) > newValue.indexOf(b.value))
                {
                    return -1;
                }
                else{
                    return 0;
                }
            });
            
            this.indeterminate = true;
            this.allSelected = false;
        }
    },
    "crop.filter"(val) {
        //console.log(val == null || val == "",!this.Category)
        if(!this.IsNullEmpty(val) ){
            this.trade.mainTradeItems = this.trade.originMainTradeItems.filter((item) => item.name.includes(val))
            this.trade.mainTradeItems.sort((a,b) =>(this.selected.indexOf(a.value) > this.selected.indexOf(b.value) ? -1 : 0));
        }
        else if(this.IsNullEmpty(val) && !this.Category){
            //console.log("crop.filter is not null")
            let temp = this.trade.originMainTradeItems;
            this.trade.mainTradeItems = temp.sort((a,b) =>(this.selected.indexOf(a.value) > this.selected.indexOf(b.value) ? -1 : 0));
        }else{
            this.Category = false;
        }
    }
}
};

</script>

<style lang="scss" scoped>
.crop_md{
    display: flex;
    align-items:center;
    margin-bottom: 1rem;

    &.crop_title{
        justify-content: center;
    }
    &.table_title{
        text-align: center;
    }
    &.md9{
        width: 100%;
    }
}
.card-body{
    padding: 0.5rem;
}
.card_md4{
    padding: 0.1rem;
    font-size: 22px;
    font-weight: 800;
    color: #ffffff;
    border-radius: 10px;
    width: 100%;
    &.orange {
        background-color: #f0b209;
    }
    &.gray{
        background-color: #4F4F4F;
    }
}
.crop_card{
    background-color: #e3dfdf;
    border: 0;
    margin-right: 0.1rem;
    font-weight: 700;
}
.mycrop{
    background-color: #eeeef0;
    border: 0;
    margin-right: 0.2rem;
    font-weight: 700;
}
.warning_col{
    margin: 0.1rem;
}
.warning_card{
    margin-left: 0.01rem;
}
.warning-btn {
    /* font-size: smaller; */
    background: #ff614c;
    border-color: #ff614c;
    color: white;
    height: 80px;
}
.warning-btn:hover {
    background: #db3c30 !important;
    border-color: #db3c30 !important;
}
.notice-btn {
/* font-size: smaller; */
    background: #f5b847;
    border-color: #f5b847;
    color: white;
    height: 80px;
}
.notice-btn:hover {
    background: #d98e3f !important;
    border-color: #d98e3f !important;
}

.warning_crop{
    border-color:#282950;
    border-radius: 10px;
    background-color: #0c0c0d;
    padding: 1rem 1rem 0 1rem;
    color: #ffffff;
}
.warning_crop_col{
    margin-bottom: 0.5rem;
    width: 100%;
}
.crop_btn{
    button{
        width: 100%;
        background-color: #e6781e;
        border: 1px solid;
        border-color: #e6781e;
        color: white;
        font-weight: bolder;
        min-height: 30px;
        border-radius: 5px;
        font-size: large;
    }
    .btn_active{
        box-shadow: rgba(255, 255, 255, 0.16) 0px 1px 4px, rgb(255, 255, 255) 0px 0px 0px 3px;
    }
    
}

.crop_effect{
    padding: 1rem;
    border-color:#ffffff;
    border:1px solid;
    border-radius: 5px;
    background-color: #1e1f44;
    min-height: 80px;
}
.selectItem{
    max-height: 60vh; 
    overflow: auto; 
    margin-top:5px; 
    padding:10px;
    border:1px #4C4C4C solid;
    border-radius: 5px;
}
.white-text-btn {
    color: rgb(255, 255, 255);
    margin-right: 0.1em;
    border: none !important;
    display: inline-block;
    padding: 0.3em;
    margin-bottom: 0.1em;
    &.blue {
        background-color: rgb(22, 155, 213);
    }

    &.orange {
        background-color: rgb(234, 123, 13);
    }

    &.green {
        background-color: rgb(112, 182, 3);
    }

    &.purple {
        background-color: rgb(194, 128, 255);
    }

    &.darkblue{
        background-color: rgb(74, 91, 217);
    }

    &.yellow{
    background-color: rgb(233, 210, 37);
    }

    &.brown{
        background-color: rgb(164, 109, 38);
    }

    &.gray{
        background-color: rgb(103, 101, 106);
    }
}
</style>